import Button from "../../Common/components/Buttons/Button/Button";
import MsxIcons from "../../Common/components/Icons/MsxIcons/MsxIcons";
import ToggleInput from "../../Common/components/Inputs/ToggleInput/ToggleInput";

const TopSection = ({ hideDetails, setHideDetails, mandatoryfieldsMissing }) => {
  return (
    <>
      <div className="flex ml-3 justify-between">
        <div
          className={`border-[1px] bg-[#FFDAD6] text-[#CC0000] inline-block rounded-l-md rounded-r-md h-4 ${
            mandatoryfieldsMissing === 0 ? "invisible" : ""
          }`}
        >
          <div className="flex step-3">
            <MsxIcons name="info" className="text-[#CC0000] mt-[1px] mb-[1px] ml-[1px]" size="nano" />
            <Button className="px-1 rounded-l-md text-[10px]"> {mandatoryfieldsMissing} Mandatory field</Button>
          </div>
        </div>
        <div className="flex border-solid border-l-[1px]" />
        <div className="step-2 flex -mt-[2px] mr-3">
          <span className="transform scale-75">
            <ToggleInput
              checked={hideDetails}
              onChange={(e) => {
                setHideDetails(e);
              }}
              switchable
            />
          </span>
          <span className="text-[12px] mt-[2px]">{hideDetails ? "Hide details" : "Show details"}</span>
        </div>
      </div>
    </>
  );
};

export default TopSection;
